var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22 38.85V25.15L10 18.2V31.9L22 38.85ZM26 38.85L38 31.9V18.2L26 25.15V38.85ZM22 43.45L8 35.4C7.36667 35.0333 6.875 34.55 6.525 33.95C6.175 33.35 6 32.6833 6 31.95V16.05C6 15.3167 6.175 14.65 6.525 14.05C6.875 13.45 7.36667 12.9667 8 12.6L22 4.55C22.6333 4.18333 23.3 4 24 4C24.7 4 25.3667 4.18333 26 4.55L40 12.6C40.6333 12.9667 41.125 13.45 41.475 14.05C41.825 14.65 42 15.3167 42 16.05V31.95C42 32.6833 41.825 33.35 41.475 33.95C41.125 34.55 40.6333 35.0333 40 35.4L26 43.45C25.3667 43.8167 24.7 44 24 44C23.3 44 22.6333 43.8167 22 43.45ZM32 17.05L35.85 14.85L24 8L20.1 10.25L32 17.05ZM24 21.7L27.9 19.45L16.05 12.6L12.15 14.85L24 21.7Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.3f701cbb.svg";
export { ForwardRef as ReactComponent };